export const renderStars = (rating = 0) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

  return (
    <>
      {Array.from({ length: fullStars }, (_, i) => (
        <i key={`full-${i}`} className="active icofont-star"></i>
      ))}

      {halfStar && <i className="half icofont-star" key="half-star"></i>}

      {Array.from({ length: emptyStars }, (_, i) => (
        <i key={`empty-${i}`} className="inactive icofont-star"></i>
      ))}
    </>
  );
};